"use client";
import BasketIcon from "@/app/assets/images/svg/basket.svg";
import CloseIcon from "@/app/assets/images/svg/xmark.svg";
import { useScopedI18n } from "@/i18n/client";
import { useCartContext } from "@/providers/CartContextProvider";
import * as Dialog from "@radix-ui/react-dialog";
import { useState } from "react";
import Button from "@/components/UI/Button/Button";
import styles from "./MiniCart.module.scss";
import MiniCartItem from "./MiniCartItem/MiniCartItem";
import { CheckoutButton } from "../CheckoutButton/CheckoutButton";
import useStoreKeys from "@/hooks/useStoreKeys";
import useIntellisuggestTracking from "@/hooks/useIntelliSuggestTracking";
import { useDataLayerContext } from "@/datalayer/DataLayerContextProvider";

const MiniCart = () => {
	const { cart, totalItems, datalayerProducts } = useCartContext();
	const scopedT = useScopedI18n("cart");
	const [miniCartOpen, setMiniCartOpen] = useState(false);
	const { store, lang } = useStoreKeys();

	const { viewCart } = useDataLayerContext();
	const { basketContents } = useIntellisuggestTracking();

	return (
		<>
			<button
				type={"button"}
				className={styles.basketIcon}
				onClick={() => {
					setMiniCartOpen(true);
					if (cart && datalayerProducts) {
						viewCart(cart, datalayerProducts);
					}

					if (cart?.line_items.physical_items.length) {
						basketContents?.(cart.line_items.physical_items);
					}
				}}
				aria-label='View Cart'
			>
				<BasketIcon onClick={() => setMiniCartOpen(true)} />
				{totalItems > 0 && <div className={styles.counter}> {totalItems}</div>}
			</button>
			<Dialog.Root open={miniCartOpen}>
				<Dialog.Portal>
					<Dialog.Overlay
						className={styles.overlay}
						onClick={() => setMiniCartOpen(false)}
					/>
					<Dialog.Content className={styles.minicart}>
						<div className={styles.header}>
							{`${scopedT("cart")} (${totalItems})`}
							<Dialog.Close
								className={styles.close}
								asChild
								onClick={() => setMiniCartOpen(false)}
							>
								<CloseIcon />
							</Dialog.Close>
						</div>
						<div className={styles.items}>
							{totalItems <= 0 && (
								<div className={styles.empty}>{scopedT("emptyCart")}</div>
							)}
							{totalItems > 0 &&
								cart !== undefined &&
								cart.line_items.physical_items.map((item) => {
									return (
										<MiniCartItem
											key={item.id}
											item={item}
											handleCartModalClose={() => setMiniCartOpen(false)}
										/>
									);
								})}
						</div>
						{totalItems > 0 && (
							<div className={styles.actions}>
								<CheckoutButton>{scopedT("checkout")}</CheckoutButton>
								<Button
									variant={"secondary"}
									as='link'
									onClick={() => setMiniCartOpen(false)}
									href={`/${store}/${lang}/cart`}
								>
									{scopedT("cart")}
								</Button>
							</div>
						)}
					</Dialog.Content>
				</Dialog.Portal>
			</Dialog.Root>
		</>
	);
};

export default MiniCart;
